import { render } from "./AgentGroupDetails.vue?vue&type=template&id=52516df2"
import script from "./AgentGroupDetails.vue?vue&type=script&lang=js"
export * from "./AgentGroupDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__